import React from 'react';

function EvidenceTimezoneToggle({ mode, setMode, localLabel }) {
  return (
    <div className="timezone-toggle" role="group" aria-label="Evidence timestamp timezone">
      <span className="timezone-toggle-label">Timestamps</span>
      <button
        type="button"
        className={`timezone-toggle-btn ${mode === 'local' ? 'active' : ''}`}
        onClick={() => setMode('local')}
        title="Show timestamps in your local timezone"
      >
        {localLabel}
      </button>
      <button
        type="button"
        className={`timezone-toggle-btn ${mode === 'gmt' ? 'active' : ''}`}
        onClick={() => setMode('gmt')}
        title="Show timestamps in GMT/UTC for evidence standards"
      >
        GMT / UTC
      </button>
    </div>
  );
}

export default EvidenceTimezoneToggle;
